<template>
  <div class="m-support">
    <!-- <img class="m-page-banner" src="../../assets/images/support_banner.jpg" alt=""> -->
    <div class="m-page-banner"></div>
    <div class="m-support-content">
      <div class="module-title">服务体系</div>
      <div class="module-desc">安心保障 贴心服务</div>
      <div class="m-support-swiper-wrap">
        <MSwiper :swiperLength="supportList.length" :swiperType="2">
          <div class="support-item" v-for="(item, index) in supportList" :key="index" :slot="`swiper-${index}`">
            <img class="support-img" :src="item.imgUrl" alt="">
            <p class="support-title">{{item.title}}</p>
            <div class="support-desc">{{item.desc}}</div>
          </div>
        </MSwiper>
      </div>
      <div class="m-support-tel">
        <div class="module-title">服务体系</div>
        <div class="tel-content">
          <img src="../../assets/images/support_phone.png" alt="">
          <p>400-661-6666</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MSwiper from './components/MSwiper'
import scrollreveal from 'scrollreveal'
export default {
  data() {
    return {
      supportList: [{
        imgUrl: require('../../assets/images/support/system_1.png'),
        title: '先进、实用的教学平台',
        desc: '“云+端”全功能板块助力课前、课中、课后教与学。实现教师分层教学、精准教学，学生个性化学习。'
      }, {
        imgUrl: require('../../assets/images/support/system_3.png'),
        title: '标准、高效的课型模式',
        desc: '经长期探索总结出的“三翻二段十环节”教学模式，通过合作学校的实践检验，让课堂教学真正实现了“以学定教，先学后教，以学生为中心”。'
      }, {
        imgUrl: require('../../assets/images/support/system_4.png'),
        title: '有温度的驻校教研服务',
        desc: '以驻校教研为核心的高品质运维体系支撑下的教师培训、听评课等高效教研活动有效地促进信息技术与教育教学的深度融合，“走出去、请进来”通过全国性、区域性的多种多样的活动为教师搭建展示交流学习的平台，提升教师职业幸福感。'
      }],
    }
  },
  mounted() {
    this.$nextTick(() => {
      let that = this
      setTimeout(() => {
        that.setAnimation()
      }, 100)
    })
  },
  methods: {
    // 动画
    setAnimation() {
      scrollreveal().reveal('.m-support .module-title', {
        duration: 1200, //动画的时长
        origin: 'bottom', //动画开始的位置，'bottom', 'left', 'top', 'right'
        reset: true, //回滚的时候是否再次触发动画
        mobile: true, //在移动端是否使用动画
        distance: '40px', //滚动的距离，单位可以用%，rem等
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-support .module-desc', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-support .tel-content', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
    }
  },
  components: {
    MSwiper
  }
}
</script>
<style lang="scss" scoped>
.m-support {
  width: 100%;
  .m-page-banner {
    width: 100%;
    display: block;
    height: 4.5rem;
    background: url('../../assets/images/support_banner.jpg') no-repeat;
    background-position: center top;
    background-size: cover;
  }
  .module-title {
    font-size: .5rem;
    font-weight: 500;
    color: #393332;
    line-height: .48rem;
    text-align: center;
  }
  .module-desc {
    font-size: .33rem;
    font-weight: 400;
    color: #595757;
    line-height: .32rem;
    margin-top: .3rem;
    text-align: center;
  }
  .m-support-content {
    margin-top: .96rem;
  }
  .m-support-swiper-wrap {
    width: 100%;
    .support-item {
      width: 5rem;
      height: 7rem;
      background: #FFFFFF;
      box-shadow: .01rem .13rem .4rem .02rem rgba(61, 61, 61, 0.25);
      // box-shadow: .06rem .07rem .1rem 0px rgba(61, 61, 61, 0.25);
      border-radius: .1rem;
      padding: .56rem .5rem 0;
      margin: 0 auto;
      margin-top: .82rem;
      margin-bottom: .5rem;
      .support-img {
        width: 2.32rem;
        height: 2.32rem;
        display: block;
        margin: 0 auto;
      }
      .support-title {
        text-align: center;
        font-size: .42rem;
        font-weight: 500;
        color: #3E3A39;
        line-height: .42rem;
        margin: .42rem 0 .2rem 0;
      }
      .support-desc {
        font-size: .29rem;
        font-weight: 400;
        color: #595757;
        line-height: .46rem;
        text-align: justify;
      }
    }
  }
  .m-support-tel {
    margin-top: 1.8rem;
    margin-bottom: 1.5rem;
    .tel-content {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: .39rem;
      font-weight: 500;
      color: #595757;
      margin-top: .4rem;
      img {
        width: .46rem;
        height: .46rem;
        margin-right: .18rem;
      }
    }
  }
}
</style>